export var CostManagementRecommendationsTypes;
(function (CostManagementRecommendationsTypes) {
    CostManagementRecommendationsTypes["DROP_UNUSED_METRICS"] = "DROP_UNUSED_METRICS";
    CostManagementRecommendationsTypes["LOG_ANALYTICS_PLAN_UPGRADE"] = "LOG_ANALYTICS_PLAN_UPGRADE";
})(CostManagementRecommendationsTypes || (CostManagementRecommendationsTypes = {}));
//# sourceMappingURL=cost-management-recommendations.enum.js.map